






































































































import { ref, computed, defineComponent } from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';
import { SETTINGS_ICON } from '@front-app/vendor/icon-definitions';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useTranslate } from '@front-app/hooks/useTranslate';
import Draggable from 'vuedraggable';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import DraggableStepCard from './DraggableStepCard.vue';
import CompletionCreditsBadge from '../components/CompletionCreditsBadge.vue';

export default defineComponent({
	components: {
		Draggable,
		FontAwesomeIcon,
		IconButton,
		ChevronIcon,
		PlusButton,
		DraggableStepCard,
		CompletionCreditsBadge,
	},
	props: {
		moduleId: {
			type: String,
			required: true,
		},
		partId: {
			type: String,
			required: true,
		},
		isSelected: Boolean,
	},
	setup(props, ctx) {
		const programsStore = getLearningProgramsStore();
		const part = computed(() => programsStore.getPart(props.partId));
		const addStep = (e: Event) => {
			ctx.emit('create-step', { opener: e.target });
		};
		const handleDragInput = (steps: string[]) => {
			programsStore.reorderPartSteps(props.moduleId, props.partId, steps);
		};
		const isPartExpanded = ref(false);
		const $t = useTranslate(ctx);
		return {
			part,
			isPartExpanded,
			chevronButtonSize: Size.SMALL,
			actionButtonSize: Size.SMALL,
			addStep,
			deleteStep(partId: string, stepId: string) {
				// eslint-disable-next-line no-alert
				const shouldDelete = window.confirm($t('lms.admin.delete-step-confirmation') as unknown as string);
				if (!shouldDelete) {
					return;
				}
				programsStore.deleteStep(partId, stepId);
			},
			handleDragInput,
			addStepButtonSize: Size.TINY,
			SETTINGS_ICON,
		};
	},
});
